import { analyticsLogPageView } from '@src/utils/analytics';

export const ColumnsPageView = {
  logPageViewColumnsList: () => analyticsLogPageView(window.location.pathname, undefined, 'コラムトップ'),
  logPageViewColumnsDetail: (column_title: string) => analyticsLogPageView(window.location.pathname, undefined, column_title)
};
